var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('nav-bar',{attrs:{"title":_vm.title}})],1),_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.pInfo)}})]),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }